"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tag_1 = require("@Components/Tag");
const TagsBlock = (props) => {
    var _a;
    return (react_1.default.createElement("div", { className: 'tags-block' }, (_a = props.groups) === null || _a === void 0 ? void 0 : _a.map((item) => (react_1.default.createElement(Tag_1.TagComponent, { key: item.name, type: 'primary', name: item.name })))));
};
exports.default = TagsBlock;
